import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Label } from 'reactstrap'

/**
 * @param {{
 *    xs: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
 *    sm: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
 *    md: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
 *    lg: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
 *    xl: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
 *    alignRightAt: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
 *    noPadding: boolean
 *    className: string
 *    htmlFor?: string
 * }} props
 * @returns {React.Component}
 */
const ZariLabel = ({ text, className, alignRightAt, noPadding, ...props }) => {
  const alignmentClassName = React.useMemo(() => {
    if (alignRightAt) {
      if (alignRightAt === 'xs') {
        return 'text-right'
      }
      return `text-${alignRightAt}-right`
    }
    return null
  }, [alignRightAt])

  return (
    <Label
      {...props}
      className={clsx('text-truncate zari-slim-label', className, alignmentClassName, {
        'no-padding': noPadding
      })}
      size='sm'
    >
      {text}
    </Label>
  )
}

ZariLabel.propTypes = {
  xs: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  alignRightAt: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  htmlFor: PropTypes.string,
  className: PropTypes.string,
  noPadding: PropTypes.bool
}

export default ZariLabel
